import { safeJsonParse } from "app/UtilitiesAndConstants/UtilityFunctions/safeJsonParse";

import { EPresetOption } from "app/common/keyword-research/website-keywords/competitiveFilterPresets";

export const getCorrectedParamsForPresetSelection = (
    /** all of the current params */
    params: Record<string, string | number | boolean>,
    /** the new params that are about to be set (not yet set) */
    newValues: Record<string, string | number | boolean>,
) => {
    const newParams = { ...params, ...newValues };
    const keys = params.pageFilter ? safeJsonParse(params.pageFilter as string, []) : (params.key as string).split(",");

    // in case we no are no longer in compare mode
    if (keys.length === 1) {
        return newParams;
    }

    // in case we are switching from a preset to another preset
    if (params.trafficPreset !== newParams.trafficPreset) {
        switch (newParams.trafficPreset) {
            case EPresetOption.Opportunities:
                return {
                    ...newParams,
                    IncludeNoneBranded: true,
                    IncludeBranded: false,
                    volumeFromValue: params.volumeFromValue ?? 10,
                };
            default:
                return {
                    ...newParams,
                    IncludeNoneBranded: params.IncludeNoneBranded,
                    IncludeBranded: params.IncludeBranded,
                    volumeFromValue: params.volumeFromValue ?? 10,
                };
        }
    }
    // in case branded filter no longer aligns with the preset
    if (newParams.IncludeNoneBranded !== true && params.trafficPreset === EPresetOption.Opportunities) {
        return { ...newParams, trafficPreset: undefined };
    }

    return newParams;
};
